export const globalConst = {

  SHOW_LOADING: 'SHOW_LOADING',
  CLOSE_LOADING: 'CLOSE_LOADING',
  OPEN_SIDEBAR: 'OPEN_SIDEBAR',
  CLOSE_SIDEBAR: 'CLOSE_SIDEBAR',
  SEND_MESSAGE: 'SEND_MESSAGE',
  GET_AD: 'GET_AD',
}